<template>
	<div class="w-full max-w-6xl mx-auto px-8 pt-12 pb-20 lg:pt-20 md:flex">
		<div class="md:w-1/2 type-1000 md:type-1200 font-70 mb-10">
			<p class="text-secondary md:max-w-md">{{ subheading }}</p>
			<p class="font-70 md:max-w-md">{{ heading }}</p>
		</div>
		<div class="md:w-1/2">
			<form class="md:max-w-md" @submit="submit">
				<div class="w-full mb-4 md:mb-10">
					<label class="text-mono-300" for="email">{{
						uiCopy.email
					}}</label>
					<input
						required
						v-model="email"
						id="email"
						type="email"
						class="custom-input"
					/>
				</div>
				<template v-if="optIn">
					<div class="mb-10 flex">
						<div class="w-1/6 md:w-1/12">
							<input
								id="consent"
								class="form-checkbox h-6 w-6"
								required
								type="checkbox"
							/>
						</div>
						<label
							for="consent"
							class="w-5/6 md:w-11/12 text-mono-500 inner-links"
							v-html="uiCopy.consent"
						></label>
					</div>
				</template>
				<button type="submit" class="btn-primary w-full">
					{{ uiCopy.seeResults }}
				</button>
				<p class="mt-10 md:mt-24">
					{{ privacy }}
				</p>
			</form>
		</div>
	</div>
</template>

<script>
export default {
	data: function () {
		return {
			email: '',
		}
	},
	props: {
		heading: { type: String },
		subheading: { type: String },
		privacy: { type: String, required: true },
		uiCopy: { type: Object, required: true },
		optIn: { type: Boolean, required: true },
	},
	methods: {
		submit: function (e) {
			e.preventDefault()
			this.$emit('slide-next', this.email)
		},
	},
}
</script>
